import { Component, OnInit,Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';

export interface DialogData { 
  row:any
}
@Component({
  selector: 'app-informacion-pedido',
  templateUrl: './informacion-pedido.component.html',
  styleUrls: ['./informacion-pedido.component.scss']
})
export class InformacionPedidoComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<InformacionPedidoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) { }

  ngOnInit() {
  }

}
